import { combineReducers } from 'redux'

import Dashboard from '../reducer/dashboard/Reducer'


export default combineReducers({
    dashboard: Dashboard,
   
})
